import React from "react";
import PropTypes from "prop-types";
import ReactTooltip from "react-tooltip";
import { FileCopy, ErrorOutline } from "@material-ui/icons";

import reloadAccount from "../../../../assets/img/bank-transfer.svg";
import { discoverService } from "../../../../app/discover-service";
import { translate as t } from "../../../../infrastructure/translate/localization";

import "./balance-sections.scss";

const copyText = (id) => {
  const text = document.getElementById(id);
  text.select();
  document.execCommand("copy");
};

const ReloadByTransference = ({ accountId }) => {
  const cobeeIban = discoverService("COBEE_IBAN");
  return (
    <div className="balance-hidden-content balanceSection">
      <ReactTooltip
        delayHide={1000}
        className="tooltipMessage"
        place="top"
        effect="solid"
        type="light"
        isCapture
      />
      <div className="thumbnail">
        <img src={reloadAccount} alt="reload transference" />
        <span className="title-balance-section">
          {t("my-account-section.transfert-recharge")}
        </span>
      </div>

      <div className="copy-info">
        <p>{t("my-account-section.transfert-next-data")}</p>
        <p>{t("my-account-section.time-to-receive")}</p>
        <p className="alert alert-info">
          <ErrorOutline className="exclamationIcon" fontSize="small" />
          <strong className="uppercase">
            {t("my-account-section.no-touch")}{" "}
          </strong>
          {t("my-account-section.no-touch-save")}
        </p>

        <div className="copy-container">
          <strong>IBAN:</strong>
          <div className="copy-content">
            <input id="iban" type="text" readOnly value={cobeeIban} />
            <button
              type="button"
              className="copy"
              data-tip={t("my-account-section.copied")}
              data-event="click focus"
              onClick={() => copyText("iban")}
            >
              <FileCopy fontSize="small" /> {t("actions.copy")}
            </button>
          </div>
        </div>

        <div className="copy-container">
          <strong className="copy-title">
            {t("my-account-section.concept")}:
            <ErrorOutline
              className="exclamationIcon"
              data-tip={t("my-account-section.concept-tooltip")}
            />
          </strong>
          <div className="copy-content">
            <input
              id="concept"
              type="text"
              readOnly
              value={`${accountId}-B88243233`}
            />
            <button
              type="button"
              className="copy"
              data-tip={t("my-account-section.copied")}
              data-event="click focus"
              onClick={() => copyText("concept")}
            >
              <FileCopy fontSize="small" /> {t("actions.copy")}
            </button>
          </div>
        </div>

        <div className="copy-container">
          <strong>{t("my-account-section.addressee")}:</strong>
          <div className="copy-content">
            <input
              id="addressee"
              type="text"
              readOnly
              value="Pecunia Cards EDE SL"
            />
            <button
              type="button"
              className="copy"
              data-tip={t("my-account-section.copied")}
              data-event="click focus"
              onClick={() => copyText("addressee")}
            >
              <FileCopy fontSize="small" /> {t("actions.copy")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

ReloadByTransference.propTypes = {
  accountId: PropTypes.string.isRequired,
};

export default ReloadByTransference;
